<template>
    <div class="select-treatment-container">
        <div class="cita-header">
            <BackButton />
            <div class="titulo">2º Elige el tipo de cita:</div>
        </div>
        <div class="select-treatment">
            <div
                class="card"
                v-for="treatment in treatments"
                :key="treatment.name"
                @click="selectTreatment(treatment.value)"
            >
                <div class="card-title">{{ treatment.name }}</div>
                <div class="card-content">
                    <img
                        :src="require('@/assets/img/' + treatment.image)"
                        alt="Treatment Image"
                        class="treatment-image"
                    />
                    <div class="treatment-details">
                        <button class="info-button" @click.stop="openModal(treatment)">Más Info</button>
                    </div>
                </div>
                <button class="arrow-button">
                    <button class="arrow-button">
                        <span style="font-weight: bold">Continuar</span>
                        <svg
                            class="arrow-icon"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 492.004 492.004"
                            xml:space="preserve"
                        >
                            <path
                                d="M382.678 226.804 163.73 7.86C158.666 2.792 151.906 0 144.698 0s-13.968 2.792-19.032 7.86l-16.124 16.12c-10.492 10.504-10.492 27.576 0 38.064L293.398 245.9l-184.06 184.06c-5.064 5.068-7.86 11.824-7.86 19.028 0 7.212 2.796 13.968 7.86 19.04l16.124 16.116c5.068 5.068 11.824 7.86 19.032 7.86s13.968-2.792 19.032-7.86L382.678 265c5.076-5.084 7.864-11.872 7.848-19.088.016-7.244-2.772-14.028-7.848-19.108z"
                            />
                        </svg>
                    </button>
                </button>
            </div>
        </div>

        <!-- Modal -->
        <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
            <div class="modal-container">
                <div class="modal-content">
                    <button class="close-button2" @click="closeModal">&times;</button>
                    <h4>{{ selectedTreatment.name }}</h4>
                    <img
                        :src="require('@/assets/img/' + selectedTreatment.image)"
                        alt="Treatment Image"
                        class="modal-image"
                    />
                    <p>{{ selectedTreatment.description }}</p>
                    <button class="close-button" @click="closeModal">Cerrar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BackButton from "@/components/BackButton.vue"; // Importa el botón de retroceso

export default {
    components: {
        BackButton, // Registra el componente del botón de retroceso
    },
    data() {
        return {
            treatments: [
                {
                    name: "1ª - visita implantes / encías",
                    description:
                        "Nuestros especialistas en Periodoncia y Cirugía trazarán un plan personalizado para mejorar la salud y apariencia de tus encías. Además en casos complejos realizan una planificación completa solo para ti coordinándose con el resto de especialistas para darte la solución más completa y duradera a nivel funcional y estético.",
                    image: "implantes.png", // Reemplaza con la URL real de la imagen
                    value: "implantes",
                },
                {
                    name: "1ª - visita ortodoncia",
                    description:
                        "¿Necesitas mejorar tu mordida y la alineación de tus dientes? Evaluaremos tu sonrisa y te explicaremos cómo mejorarla mediante nuestros sistemas de ortodoncia.",
                    image: "ortodoncia.png", // Reemplaza con la URL real de la imagen
                    value: "ortodoncia",
                },
                {
                    name: "1ª - visita estética",
                    description:
                        "Si quieres sonreír como nunca antes, te ayudamos a conseguirlo mediante tratamientos como el blanqueamiento o las microcarillas. Descubre con nuestros especialistas cómo transformar por completo el aspecto de tu sonrisa.",
                    image: "estetica.jpg", // Reemplaza con la URL real de la imagen
                    value: "estetica",
                },
                {
                    name: "1ª - visita general",
                    description:
                        "Indicada si quieres conocer el estado general de tu salud bucodental o si hace más de un año de tu última consulta en el dentista. Te realizaremos una revisión completa para obtener un diagnóstico integral de tu caso.",
                    image: "conservadora.jpg", // Reemplaza con la URL real de la imagen
                    value: "conservadora",
                },
            ],
            showModal: false,
            selectedTreatment: null,
        };
    },
    methods: {
        selectTreatment(treatment) {
            this.$store.commit("setTreatment", treatment);
            this.$router.push({ name: "Cita" });
        },
        openModal(treatment) {
            this.selectedTreatment = treatment;
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
            this.selectedTreatment = null;
        },
    },
};
</script>

<style scoped>
.select-treatment {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 20px;
}

h3 {
    margin-bottom: 20px;
}

.card {
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 8px;
    margin: 10px;
    width: 100%;
    min-height: 6.5rem;
    max-width: 600px;
    cursor: pointer;
    transition: box-shadow 0.3s;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);
    position: relative;
}

.card-title {
    margin: 0.7rem;
    font-size: 1rem;
    font-weight: bold;
    width: 100%;
    text-align: center;
    margin: 0.9rem 0;
    color: #2f3e4a;
}

.card:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
}

.card-content {
    display: flex;
    width: 100%;
    height: 4rem;
    align-items: center;
    position: absolute;
    bottom: 0;
}
.select-treatment-container {
    margin-top: 2rem;
}
.treatment-image {
    width: 30%;
    height: 100%;
    object-fit: cover;
    border-radius: 0 8px 0 8px;
}

.treatment-details {
    flex-grow: 1;
    padding: 10px;
    width: 70%;
    padding-left: 1rem;
}

.treatment-details p {
    margin: 0;
    font-size: 1rem;
    color: #333;
    display: flex;
    align-items: center;
}

.info-button {
    background-color: transparent;
    border: none;
    color: var(--blue-color);
    cursor: pointer;
    padding: 0;
    text-decoration: underline;
    font-size: 16px;
}

.arrow-button {
    position: absolute;
    bottom: 0;
    right: 0;
    background-color: var(--pink-color);
    border: none;
    cursor: pointer;
    padding: 3px 7px 1px;
    transition: background-color 0.3s;
    border-radius: 8px 0 8px;
    width: 35%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 15px;
}

.arrow-button:hover {
    background-color: var(--blue-color);
}

.arrow-icon {
    padding: 2px;
    width: 20px;
    height: 20px;
    fill: white; /* color del icono */
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}
.modal-container {
    width: 90%;
    max-width: 450px; /* Asegura que el modal no sea demasiado ancho */
    margin: auto; /* Centra horizontalmente */
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    text-align: center;
    position: relative;
}
.modal-content {
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    max-width: 450px;
    text-align: center;
}
.modal-content p {
    text-align: left;
}

.modal-image {
    width: 100%;
    height: auto;
    border-radius: 8px;
    margin-bottom: 15px;
}

.close-button {
    background-color: var(--pink-color);
    border: none;
    color: #fff;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    margin-top: 10px;
}

.cita-header {
    display: flex;
    align-items: center;
    margin: 0 0.5rem;
}
.cita-header .titulo {
    font-size: 20px;
    font-weight: bold;
}

/* Estilo del botón de cierre (cruz "X") */
.close-button2 {
    position: absolute;
    top: 10px;
    right: 10px;
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #333;
}

.close-button2:hover {
    color: var(--blue-color);
}

@media (min-width: 768px) {
    .select-treatment {
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-around;
    }
    .card {
        max-width: 45%; /* Ajusta según tus necesidades */
    }
    .select-treatment-container {
        margin-top: 4rem;
    }
}
</style>
